var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"warning",staticStyle:{"padding":"0 1em","text-align":"left","min-height":"20em"}},[_vm._v(" 請注意~無可執行功能 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }